import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { track } from '../api/track'

// Auto-fires a page_view event whenever the route changes. Mounted once at
// the App root (inside <BrowserRouter>) so every navigation in the SPA emits
// a ping. Skips the /admin/* and /partner/* trees — neither admin browsing
// nor travel-agency partners checking their commission are the customer
// funnel, and counting them would inflate every acquisition metric.
export function usePageView(): void {
  const loc = useLocation()
  useEffect(() => {
    if (loc.pathname.startsWith('/admin') || loc.pathname.startsWith('/partner')) return
    // `?preview=1` mounts a shadow version of a page at its real URL, so the
    // pathname alone can't tell the two apart. Tag the event when it's set,
    // otherwise leave the payload exactly as it was (undefined keys are
    // dropped by JSON.stringify) so historical page_view data stays comparable.
    const preview = new URLSearchParams(loc.search).get('preview')
    track('page_view', { path: loc.pathname, preview: preview || undefined })
  }, [loc.pathname, loc.search])
}
